// Generated by foundation. Each catalogs/<module>/{en,ar}.json pair is owned by that module's builder.
import commonEn from '../catalogs/common/en.json';
import commonAr from '../catalogs/common/ar.json';
import identityEn from '../catalogs/identity/en.json';
import identityAr from '../catalogs/identity/ar.json';
import tenancyEn from '../catalogs/tenancy/en.json';
import tenancyAr from '../catalogs/tenancy/ar.json';
import flagsEn from '../catalogs/flags/en.json';
import flagsAr from '../catalogs/flags/ar.json';
import billingEn from '../catalogs/billing/en.json';
import billingAr from '../catalogs/billing/ar.json';
import partnerCommissionsEn from '../catalogs/partner-commissions/en.json';
import partnerCommissionsAr from '../catalogs/partner-commissions/ar.json';
import integrationsEn from '../catalogs/integrations/en.json';
import integrationsAr from '../catalogs/integrations/ar.json';
import adminEn from '../catalogs/admin/en.json';
import adminAr from '../catalogs/admin/ar.json';
import whatsappConnectEn from '../catalogs/whatsapp-connect/en.json';
import whatsappConnectAr from '../catalogs/whatsapp-connect/ar.json';
import whatsappInboxEn from '../catalogs/whatsapp-inbox/en.json';
import whatsappInboxAr from '../catalogs/whatsapp-inbox/ar.json';
import whatsappLeadsEn from '../catalogs/whatsapp-leads/en.json';
import whatsappLeadsAr from '../catalogs/whatsapp-leads/ar.json';
import whatsappOverviewEn from '../catalogs/whatsapp-overview/en.json';
import whatsappOverviewAr from '../catalogs/whatsapp-overview/ar.json';
import whatsappCampaignsEn from '../catalogs/whatsapp-campaigns/en.json';
import whatsappCampaignsAr from '../catalogs/whatsapp-campaigns/ar.json';
import whatsappTemplatesEn from '../catalogs/whatsapp-templates/en.json';
import whatsappTemplatesAr from '../catalogs/whatsapp-templates/ar.json';
import whatsappAutomationsEn from '../catalogs/whatsapp-automations/en.json';
import whatsappAutomationsAr from '../catalogs/whatsapp-automations/ar.json';
import whatsappAiEn from '../catalogs/whatsapp-ai/en.json';
import whatsappAiAr from '../catalogs/whatsapp-ai/ar.json';
import crmEn from '../catalogs/crm/en.json';
import crmAr from '../catalogs/crm/ar.json';
import customersEn from '../catalogs/customers/en.json';
import customersAr from '../catalogs/customers/ar.json';
import leadgenEn from '../catalogs/leadgen/en.json';
import leadgenAr from '../catalogs/leadgen/ar.json';
import croEn from '../catalogs/cro/en.json';
import croAr from '../catalogs/cro/ar.json';
import quotesEn from '../catalogs/quotes/en.json';
import quotesAr from '../catalogs/quotes/ar.json';
import opportunitiesEn from '../catalogs/opportunities/en.json';
import opportunitiesAr from '../catalogs/opportunities/ar.json';
import aiEn from '../catalogs/ai/en.json';
import aiAr from '../catalogs/ai/ar.json';
import approvalsEn from '../catalogs/approvals/en.json';
import approvalsAr from '../catalogs/approvals/ar.json';
import knowledgeEn from '../catalogs/knowledge/en.json';
import knowledgeAr from '../catalogs/knowledge/ar.json';
import helpCentreEn from '../catalogs/help-centre/en.json';
import helpCentreAr from '../catalogs/help-centre/ar.json';
import adsMetaEn from '../catalogs/ads-meta/en.json';
import adsMetaAr from '../catalogs/ads-meta/ar.json';
import adsGoogleEn from '../catalogs/ads-google/en.json';
import adsGoogleAr from '../catalogs/ads-google/ar.json';
import adsLinkedinEn from '../catalogs/ads-linkedin/en.json';
import adsLinkedinAr from '../catalogs/ads-linkedin/ar.json';
import adsTiktokEn from '../catalogs/ads-tiktok/en.json';
import adsTiktokAr from '../catalogs/ads-tiktok/ar.json';
import adsSnapEn from '../catalogs/ads-snap/en.json';
import adsSnapAr from '../catalogs/ads-snap/ar.json';
import gbpEn from '../catalogs/gbp/en.json';
import gbpAr from '../catalogs/gbp/ar.json';
import reputationEn from '../catalogs/reputation/en.json';
import reputationAr from '../catalogs/reputation/ar.json';
import connectorsEn from '../catalogs/connectors/en.json';
import connectorsAr from '../catalogs/connectors/ar.json';
import deliverablesEn from '../catalogs/deliverables/en.json';
import deliverablesAr from '../catalogs/deliverables/ar.json';
import calendarEn from '../catalogs/calendar/en.json';
import calendarAr from '../catalogs/calendar/ar.json';
import reportsEn from '../catalogs/reports/en.json';
import reportsAr from '../catalogs/reports/ar.json';
import productionEn from '../catalogs/production/en.json';
import productionAr from '../catalogs/production/ar.json';
import brandingEn from '../catalogs/branding/en.json';
import brandingAr from '../catalogs/branding/ar.json';
import socialEn from '../catalogs/social/en.json';
import socialAr from '../catalogs/social/ar.json';
import emailMarketingEn from '../catalogs/email-marketing/en.json';
import emailMarketingAr from '../catalogs/email-marketing/ar.json';
import attributionEn from '../catalogs/attribution/en.json';
import attributionAr from '../catalogs/attribution/ar.json';
import visibilityEn from '../catalogs/visibility/en.json';
import visibilityAr from '../catalogs/visibility/ar.json';
import partnersEn from '../catalogs/partners/en.json';
import partnersAr from '../catalogs/partners/ar.json';
import teamEn from '../catalogs/team/en.json';
import teamAr from '../catalogs/team/ar.json';
import workspaceEn from '../catalogs/workspace/en.json';
import workspaceAr from '../catalogs/workspace/ar.json';
import mcpEn from '../catalogs/mcp/en.json';
import mcpAr from '../catalogs/mcp/ar.json';
import shellEn from '../catalogs/shell/en.json';
import shellAr from '../catalogs/shell/ar.json';
import localizationEn from '../catalogs/localization/en.json';
import localizationAr from '../catalogs/localization/ar.json';
import notificationsEn from '../catalogs/notifications/en.json';
import notificationsAr from '../catalogs/notifications/ar.json';
import commerceEn from '../catalogs/commerce/en.json';
import commerceAr from '../catalogs/commerce/ar.json';
import privacyEn from '../catalogs/privacy/en.json';
import privacyAr from '../catalogs/privacy/ar.json';
import auditRemediationEn from '../catalogs/audit-remediation/en.json';
import auditRemediationAr from '../catalogs/audit-remediation/ar.json';
import aiActivityEn from '../catalogs/ai-activity/en.json';
import aiActivityAr from '../catalogs/ai-activity/ar.json';
import growthOsEn from '../catalogs/growth-os/en.json';
import growthOsAr from '../catalogs/growth-os/ar.json';

export type Catalog = Record<string, string>;
export const CATALOGS: Record<string, { en: Catalog; ar: Catalog }> = {
  'common': { en: commonEn, ar: commonAr },
  'identity': { en: identityEn, ar: identityAr },
  'tenancy': { en: tenancyEn, ar: tenancyAr },
  'flags': { en: flagsEn, ar: flagsAr },
  'billing': { en: billingEn, ar: billingAr },
  'partner-commissions': { en: partnerCommissionsEn, ar: partnerCommissionsAr },
  'integrations': { en: integrationsEn, ar: integrationsAr },
  'admin': { en: adminEn, ar: adminAr },
  'whatsapp-connect': { en: whatsappConnectEn, ar: whatsappConnectAr },
  'whatsapp-inbox': { en: whatsappInboxEn, ar: whatsappInboxAr },
  'whatsapp-leads': { en: whatsappLeadsEn, ar: whatsappLeadsAr },
  'whatsapp-overview': { en: whatsappOverviewEn, ar: whatsappOverviewAr },
  'whatsapp-campaigns': { en: whatsappCampaignsEn, ar: whatsappCampaignsAr },
  'whatsapp-templates': { en: whatsappTemplatesEn, ar: whatsappTemplatesAr },
  'whatsapp-automations': { en: whatsappAutomationsEn, ar: whatsappAutomationsAr },
  'whatsapp-ai': { en: whatsappAiEn, ar: whatsappAiAr },
  'crm': { en: crmEn, ar: crmAr },
  'customers': { en: customersEn, ar: customersAr },
  'leadgen': { en: leadgenEn, ar: leadgenAr },
  'quotes': { en: quotesEn, ar: quotesAr },
  'opportunities': { en: opportunitiesEn, ar: opportunitiesAr },
  'cro': { en: croEn, ar: croAr },
  'ai': { en: aiEn, ar: aiAr },
  'approvals': { en: approvalsEn, ar: approvalsAr },
  'knowledge': { en: knowledgeEn, ar: knowledgeAr },
  'help-centre': { en: helpCentreEn, ar: helpCentreAr },
  'ads-meta': { en: adsMetaEn, ar: adsMetaAr },
  'ads-google': { en: adsGoogleEn, ar: adsGoogleAr },
  'ads-linkedin': { en: adsLinkedinEn, ar: adsLinkedinAr },
  'ads-tiktok': { en: adsTiktokEn, ar: adsTiktokAr },
  'ads-snap': { en: adsSnapEn, ar: adsSnapAr },
  'gbp': { en: gbpEn, ar: gbpAr },
  'reputation': { en: reputationEn, ar: reputationAr },
  'connectors': { en: connectorsEn, ar: connectorsAr },
  'deliverables': { en: deliverablesEn, ar: deliverablesAr },
  'calendar': { en: calendarEn, ar: calendarAr },
  'reports': { en: reportsEn, ar: reportsAr },
  'production': { en: productionEn, ar: productionAr },
  'branding': { en: brandingEn, ar: brandingAr },
  'social': { en: socialEn, ar: socialAr },
  'email-marketing': { en: emailMarketingEn, ar: emailMarketingAr },
  'attribution': { en: attributionEn, ar: attributionAr },
  'visibility': { en: visibilityEn, ar: visibilityAr },
  'partners': { en: partnersEn, ar: partnersAr },
  'team': { en: teamEn, ar: teamAr },
  'workspace': { en: workspaceEn, ar: workspaceAr },
  'mcp': { en: mcpEn, ar: mcpAr },
  'shell': { en: shellEn, ar: shellAr },
  'localization': { en: localizationEn, ar: localizationAr },
  'notifications': { en: notificationsEn, ar: notificationsAr },
  'commerce': { en: commerceEn, ar: commerceAr },
  'privacy': { en: privacyEn, ar: privacyAr },
  'audit-remediation': { en: auditRemediationEn, ar: auditRemediationAr },
  'ai-activity': { en: aiActivityEn, ar: aiActivityAr },
  'growth-os': { en: growthOsEn, ar: growthOsAr },
};
